export const APIEndpoints = {
  userLogin: "/v1/mobile/shop/admin/login",

  //Table Reservation foodpage
  newReservationList: "/v2/shop/custome/tablereservation/getnewrequests",
  currentReservationList: "/v2/shop/custome/tablereservation/today",
  reservationHistoryList: "/v2/shop/custome/tablereservation/gethistory",
  upcomingReservationList: "/v2/shop/custome/tablereservation/getupcominglist",
  createNewReservation: "/v2/shop/custome/tablereservation/newreservation",
  getReservationDetailsbyId: "/v2/shop/custome/tablereservation/getdata",
  updateReservationDetails: "/v2/shop/custome/tablereservation/enquiryupdate",
  upcomingWithTodays: "/v2/shop/custome/tablereservation/getupcomingwithtoday",
  getActiveTableLists: "v2/shop/custome/tablereservation/getactivetableslist",
  getAvailableTables: "v2/shop/custome/tablereservation/getavailabletables",
  deleteSingleReservation: "/v2/shop/custome/tablereservation/remove",
  reservationTiming: "v2/shop/user/diningtable/reservation/timing",
  saveReservationTiming: "/v2/shop/custome/tablereservation/savetimingadvanced",

  //Reservation messages foodpage
  sendNewMessage: "/v2/shop/custome/tablereservation/sendcustomermessage",
  getData: "/v2/shop/custome/tablereservation/getdata",

  //Reservation settings
  fetchSettings: "/settings/fetch-shop-settings",
  createNewSettings: "/settings/create-new-settings",
  updateSettings: "/settings/update-shop-settings",

  //Reservation settings Foodpage
  getSettings: "/v2/shop/custome/tablereservation/getsettings",

  //holidays
  fetchHolidaysList: "/v1/mobile/shop/holidays/reservation/history",
  fetchUpcomingHolidays: "/v1/mobile/shop/holidays/reservation/upcoming",
  createNewHoliday: "/v1/mobile/shop/holidays/reservation/addnew",
  deleteSingleHoliday: "/v1/mobile/shop/holidays/reservation/delete",

  //promotions
  fetchPromotions: "/promotions/fetch-all-promotions",
  createPromotions: "/promotions/create-new-promotion",
  deletePromotions: "/promotions/delete-promotion",
  updatePromotions: "/promotions/update-promotion-details",
  changePromotionStatus: "/promotions/change-promotion-status",

  //CMS
  fetchAllContents: "/contents/fetch-contents",
  fetchAllContentsAltered: "/contents/fetch-contents-altered",
  createNewContent: "/contents/create-content",
  updateContentDetails: "/contents/update-content",

  //Events
  fetchAllEvents: "/events/fetch",
  createEvent: "/events/create",
  updateEvent: "/events/update",
  deleteEvent: "/events/delete",

  //menu
  fetchMenuList: "/v1/mobile/shop/products/menulist",

  // Closures
  getClosures: "/v2/shop/custome/tablereservation/closure/list/active",
  closuresHistory: "/v2/shop/custome/tablereservation/closure/list/history",
  newClosure: "/v2/shop/custome/tablereservation/closure/new",
  deleteClosure: "/v2/shop/custome/tablereservation/closure/remove",

  //Settings
  shopSettings: "v2/shop/custome/tablereservation/getsettings",
  shopUpdateSettings: "/v2/shop/custome/tablereservation/updatesettings",
};
